import {TabRankingChangedPeriodType} from './TabRankingChangedPeriodType';

export class TabRankingChangedEventPayload {
    constructor(public period: TabRankingChangedPeriodType) {
    }
}
